var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "sync-panel sync-overview-panel"
  }, [_vm.alertTotalCount > 0 ? _c('div', {
    staticClass: "overview-alert"
  }, [_c('Icon', {
    staticClass: "overview-alert-icon",
    attrs: {
      "type": "ios-alert-outline"
    }
  }), _c('span', {
    staticClass: "overview-alert-text"
  }, [_vm._v(` ${$t("g0k02", "存在")} `), _c('strong', [_vm._v(_vm._s(_vm.alertTotalCount) + ` ${$t("kf51", "条")}`)]), _vm._v(` ${$t("arjlhwe", "同步告警（单位代码未匹配 ×")} ` + _vm._s(_vm.unitMismatchCount) + `${$t("2se0dm7", "，多重匹配 ×")} ` + _vm._s(_vm.multipleMatchedCount) + "）， ")]), _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('show-alerts');
      }
    }
  }, [_vm._v($t("26pwpi6", "点击处理 →"))])], 1) : _vm._e(), _c('div', {
    staticClass: "overview-stat-row"
  }, [_c('div', {
    staticClass: "overview-stat-card overview-stat-card--total"
  }, [_c('div', {
    staticClass: "overview-stat-num"
  }, [_vm._v(_vm._s(_vm.totalMemberCount))]), _c('div', {
    staticClass: "overview-stat-label"
  }, [_vm._v($t("i4y4cr6", "单位成员总数"))]), _c('div', {
    staticClass: "overview-stat-sub"
  }, [_vm._v($t("b2qwva9", "iWork 通讯录"))])]), _vm._l(_vm.overviewDownstreams, function (item) {
    return _c('div', {
      key: `stat-${item.downstreamSystem}`,
      staticClass: "overview-stat-card"
    }, [_c('div', {
      staticClass: "overview-stat-num overview-stat-num--success"
    }, [_vm._v(" " + _vm._s(item.successCount || 0) + " ")]), _c('div', {
      staticClass: "overview-stat-label"
    }, [_vm._v(" " + _vm._s(_vm.shortSystemName(item.downstreamSystem)) + ` ${$t("e698r3", "已同步")} `)]), _c('div', {
      staticClass: "overview-stat-sub"
    }, [_c('span', {
      staticClass: "overview-danger-text"
    }, [_vm._v(" " + _vm._s(_vm.downstreamFailedCount(item)) + " " + _vm._s(_vm.downstreamFailedName()) + " ")])])]);
  })], 2), _vm.overviewDownstreams.length ? _c('div', {
    class: ['overview-card-grid', {
      'overview-card-grid--single': _vm.overviewDownstreams.length === 1
    }]
  }, _vm._l(_vm.overviewDownstreams, function (item) {
    return _c('div', {
      key: item.downstreamSystem,
      staticClass: "overview-card"
    }, [_c('div', {
      staticClass: "overview-card-head"
    }, [_c('div', {
      staticClass: "overview-card-title"
    }, [_c('span', {
      staticClass: "overview-status-dot",
      class: _vm.cardStatus(item)
    }), _vm._v(" " + _vm._s(_vm.shortSystemName(item.downstreamSystem)) + ` ${$t("evvd2", "同步")} `)]), _c('span', {
      staticClass: "overview-tag",
      class: _vm.cardStatus(item)
    }, [_vm._v(" " + _vm._s(_vm.cardStatusText(item)) + " ")])]), _c('div', {
      staticClass: "overview-card-body"
    }, [_c('div', {
      staticClass: "overview-card-row"
    }, [_c('span', {
      staticClass: "overview-card-row-label"
    }, [_vm._v($t("b2232q4", "同步通道"))]), _c('span', {
      staticClass: "overview-card-row-value"
    }, [_c('span', {
      staticClass: "overview-tag",
      class: _vm.channelClass(item)
    }, [_vm._v(" " + _vm._s(_vm.channelText(item)) + " ")]), _c('span', {
      staticClass: "overview-muted"
    }, [_vm._v(_vm._s(_vm.deploymentText(item)))])])]), _c('div', {
      staticClass: "overview-card-row"
    }, [_c('span', {
      staticClass: "overview-card-row-label"
    }, [_vm._v(` ${$t("dl8p2i4", "最近推送")} `)]), _c('span', {
      staticClass: "overview-card-row-value overview-mono"
    }, [_vm._v(" " + _vm._s(_vm.formatTime(_vm.statusTime(item))) + " ")])]), _c('div', {
      staticClass: "overview-card-row"
    }, [_c('span', {
      staticClass: "overview-card-row-label"
    }, [_vm._v(` ${$t("ad62gk4", "今日推送")} `)]), _c('span', {
      staticClass: "overview-card-row-value"
    }, [_vm._v(" " + _vm._s(_vm.todayPushText(item)) + " ")])]), _c('div', {
      staticClass: "overview-card-row"
    }, [_c('span', {
      staticClass: "overview-card-row-label"
    }, [_vm._v(` ${$t("fcflf44", "登录方式")} `)]), _c('span', {
      staticClass: "overview-card-row-value"
    }, [_vm._v(" " + _vm._s(_vm.loginText(item)) + " ")])])])]);
  }), 0) : _c('div', {
    staticClass: "overview-empty-state"
  }, [_c('div', {
    staticClass: "overview-empty-icon"
  }, [_c('Icon', {
    attrs: {
      "type": "ios-git-network"
    }
  })], 1), _vm._m(0)])]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "overview-empty-content"
  }, [_c('h3', [_vm._v($t("vi9td8", "暂无下游同步状态"))]), _c('p', [_vm._v(` ${$t("lgleie1y", "当前单位还没有可展示的下游系统状态。完成同步配置后，这里会展示 UC / iHotel / iCater 的同步健康度、通道和最近同步信息。")} `)])]);
}];
export { render, staticRenderFns };